import { render, staticRenderFns } from "./c-textmask.vue?vue&type=template&id=2e37ffec&scoped=true"
import script from "./c-textmask.vue?vue&type=script&lang=js"
export * from "./c-textmask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37ffec",
  null
  
)

export default component.exports